import styled from "styled-components";

export declare type ContentContainerProps = {
  className?: string;
  $templateRows?: string;
  $mobTemplateRows?: string;
  $gap?: string;
}

export const ContentContainer = styled.div.attrs((props: ContentContainerProps) => {
  return {
    className: props.className,
    ...props,
  };
})<ContentContainerProps>`
	display: grid;
	grid-template-rows: ${props => {
    return props.$templateRows || "repeat(3, min-content)";
  }};
	gap: ${({ $gap, }) => $gap || "32px" };
	@media (min-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
		grid-template-rows: ${({ $mobTemplateRows, }) => $mobTemplateRows || "2fr" };
		gap: 24px;
	}
`;
